import { useTranslation } from 'react-i18next';
import './css/TableSummary.css';

export default function TableSummary({ tables, bookings = [] }) {
  const { t } = useTranslation();
  // Count tables by status (for available, in-service, out of service)
  const statusCounts = tables.reduce((acc, table) => {
    acc[table.status] = (acc[table.status] || 0) + 1;
    return acc;
  }, {});

  // Count actually booked tables based on bookings data
  const bookedTableIds = new Set();
  
  // Get unique table IDs from active bookings (confirmed, pending, etc.)
  bookings.forEach(booking => {
    if (
      booking.status !== 'CANCELLED' &&
      booking.status !== 'COMPLETED' &&
      booking.tables 
    ) {
      booking.tables.forEach(table => {
        bookedTableIds.add(table.tableId);
      });
    }
  });


  const available = statusCounts.AVAILABLE || 0;
  const in_service = statusCounts.IN_SERVICE || 0;
  const booked = bookedTableIds.size; // Count of unique tables with active bookings
  const outOfService = statusCounts.OUT_OF_SERVICE || 0;

  return (
    <div className="table-summary-card">
      <div className="table-summary-header">
        <h3 className="table-summary-title">{t('admin.table_management.summary.title')}</h3>
      </div>
      <div className="table-summary-content">
        <div className="status-grid">
          <div className="status-item">
            <div className="status-indicator available"></div>
            <span className="status-text">{t('status.table.available')}: {available}</span>
          </div>
          <div className="status-item">
            <div className="status-indicator in-service"></div>
            <span className="status-text">{t('status.table.in_service')}: {in_service}</span>
          </div>
          <div className="status-item">
            <div className="status-indicator booked"></div>
            <span className="status-text">{t('status.table.booked')}: {booked}</span>
          </div>
          <div className="status-item">
            <div className="status-indicator out-of-service"></div>
            <span className="status-text">{t('status.table.out_of_service')}: {outOfService}</span>
          </div>
        </div>
      </div>
    </div>
  );
}